export const colors = {
  white: '#fff',
  gray: '#fbfbfb',
  deepGray: '#9E9E9E',
  blue: '#1890ff',
  yellow: '#FDD835',
  amber: '#FFB300',
  orange: '#FFA726',
  green: '#00C853',
  redAccent: '#FF1744',
  red: '#F44336',
  deepOrange: '#FF5722',
};
